import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Prüfe Token im sessionStorage
  const token = authService.getToken();
  
  if (token && authService.isLoggedIn()) {
    // Token ist gültig und nicht abgelaufen
    // Verlängere Ablaufdatum auf 1 Minute ab jetzt (Sliding Window)
    authService.refreshTokenExpiry();
    return true;
  }

  // Nicht authentifiziert oder Token abgelaufen - Logout und zur Login-Seite
  authService.logout();
  router.navigate(['/login']);
  return false;
};
